import React, { FormEvent, memo, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Grid } from '@mui/material'
import { AnyInput, useValidatedForm } from '../anyform'
import { translate } from '../i18n'
import { ListSearchParams } from '../model'
import { SearchFilterProps } from './SearchFilter.types'

function SearchFilter<T extends ListSearchParams>({
    label,
    query,
}: SearchFilterProps) {
    const history = useHistory()
    const location = useLocation()

    const search = useMemo(() => {
        return query.get('search') ?? ''
    }, [query])
    const { bind, register } = useValidatedForm<T>()

    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const request = bind()

        query.set('search', request.search ?? '')
        query.set('page', '1')

        history.push({
            pathname: location.pathname,
            state: location.state,
            search: query.toString(),
        })
    }

    return (
        <form autoComplete="off" noValidate onSubmit={onSubmit}>
            <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                spacing={1}
            >
                <Grid item xs={12} sm>
                    <AnyInput
                        type="text"
                        name="search"
                        label={label}
                        initialValue={search}
                        register={register}
                    />
                </Grid>
                <Grid item xs="auto">
                    <Button type="submit" color="secondary" size="medium">
                        {translate('buttons.search')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default memo(SearchFilter)
